<template>
  <div class="demo-split IVR_setting" :style="screenHeight">
    <el-container :style="screenHeight">
      <el-header>
        <label class="flow-title" :title="rootName">{{rootName}}</label>
        <ul class="header">
          <li
            v-for="(item,index) in nodeData"
            v-show="item.name!='开始节点'"
            :key="index"
            :data-shape="item.shape"
            :data-color="item.color"
            :data-size="item.size"
            draggable
            class="nodeClass"
            @dragstart="handleDragstart"
            @dragend="handleDragEnd($event,item)"
          >
            <div class="nodeDiv">
              <div :style="{'background-color':item.color}" style="height: 10px;width: 10px;margin-top: 6px;"></div>
              <label style="margin-left: 3px;line-height: 23px;" :title="item.label">{{item.label}}</label>
            </div>
          </li>
          <li>
            <Tooltip placement="top" content="删除" theme="light">
              <i class="el-icon-delete" @click="handleDelete"></i>
            </Tooltip>
          </li>
          <li>
            <Tooltip placement="top" content="清空画布" theme="light">
              <i class="el-icon-delete-solid" @click="handleClear"></i>
            </Tooltip>
          </li>
          <li>
            <Tooltip placement="top" content="放大" theme="light">
              <i class="el-icon-zoom-in" @click="handleZoomIn"></i>
            </Tooltip>
          </li>
          <li>
            <Tooltip placement="top" content="缩小" theme="light">
              <i class="el-icon-zoom-out" @click="handleZoomOut"></i>
            </Tooltip>
          </li>
          <li>
            <Tooltip placement="top" content="重置" theme="light">
              <Icon type="ios-sync" style="font-size: 16.8px;" @click="handleResetZoom"></Icon>
            </Tooltip>
          </li>

          <li style="padding-left: 20px;">
            <Tooltip placement="top" content="保存" theme="light">
              <i class="el-icon-success" @click="saveFlow"/>
            </Tooltip>
          </li>
          <li style="padding-left: 10px;">
            <Tooltip placement="top" content="返回" theme="light">
              <Icon type="md-exit" style="font-size: 22px;" @click="exitPage" />
            </Tooltip>
          </li>
        </ul>
        <el-select
          v-model="nodeName"
          placeholder="请选择节点"
          clearable
          filterable
          size="small"
          @change="changeNodeStation"
          style="float: right;max-width: 150px;margin-right: 15px;">
          <el-option
            v-for="item in nodes"
            :key="item.id"
            :label="item.label"
            :value="item.id">
          </el-option>
        </el-select>
      </el-header>
      <el-container>
        <el-aside width="50px">
          <ul style="margin-top: 30px">
            <!--            <li>-->
            <!--              <Tooltip placement="right" content="全局变量" theme="light">-->
            <!--                &lt;!&ndash;<i class="el-icon-star-off" @click="showGlobalDialog"></i>&ndash;&gt;-->
            <!--                <img :src="variablesImg" @click="showGlobalDialog" class="left-icon"/>-->
            <!--              </Tooltip>-->
            <!--            </li>-->
            <!--语音文件-->
            <li>
              <Tooltip placement="right" content="语音文件" theme="light">
                <!--<i class="el-icon-folder" @click="fileDrawer=true"></i>-->
                <img :src="recordFilesImg" @click="fileDrawer=true" class="left-icon"/>
              </Tooltip>
            </li>
            <!--<li>
              <Tooltip placement="right" content="调试窗" theme="light">
                &lt;!&ndash;<i class="el-icon-s-tools" @click="testDrawer=true"></i>&ndash;&gt;
                <img :src="dialogImg" @click="testDrawer=true" class="left-icon"/>
              </Tooltip>
            </li>-->
          </ul>
        </el-aside>
      <el-main>
        <!--图的画布容器-->
        <div :id="containerId" style="background-color: white;position: relative" class="graphic-container">
        </div>
        <div :id="navId" class="win">
        </div>
      </el-main>
        </el-container>
    </el-container>
    <!--语音文件抽屉-->
    <IvrFileDrawer :file="fileDrawer" :flowId="flowId" @closeDrawer="closeDrawer"></IvrFileDrawer>
    <IvrNodeDrawer
      :nodeShow="nodeDrawer"
      :flowId="flowId"
      :model="nodeModel"
      :nodeList="nodes"
      :paramListForAll="paramList"
      :httpParamList="paramListHttp"
      @closeNodeDrawer="closeNodeDrawer"
      @updateData="receivedData"
      @updateNodeLabel="updateNode"
      @deleteRecognize="deleteRecognize"
      @deleteJudge="deleteJudge"
      @updateRecognizeLabel="updateRecognize"
      @updateJudgeLabel="updateJudgeLabel"
    ></IvrNodeDrawer>
  </div>
</template>

<script>
  import G6 from '@antv/g6'
  import {publicFunClass} from "@/components/js/PublicFunClass.js"
  import playMusicPop from '@/components/statisticsReportForm/detailedReportForm/PlayMusicPop.vue'
  import {initBehaviors} from '@/components//flow/components/behavior/ivr-index.js'
  import {uniqueId} from '@/util'
  import eventBus from "../../../util/eventBus";
  import IvrNodeDrawer from '@/components/systemSetup/CTIConfigure/IvrNodeDrawer.vue'
  import IvrFileDrawer from "@/components/systemSetup/CTIConfigure/IvrFileDrawer";
  //node img
  import recordFiles from '@/assets/image/recordFiles.png'
  import startNodeImg from '@/assets/image/start_node.png'
  export default {
    name: "IVRDetail",
    components: {playMusicPop,IvrNodeDrawer,IvrFileDrawer},
    mixins:[publicFunClass],
    props:{
      Id:String,
      name:String,
      rootName:String,
      ivrTableType:String
    },
    data () {
      return {
        paramListHttp:[],
        paramList:[],
        recordFilesImg:recordFiles,
        roleList: JSON.parse(localStorage.getItem('roleList')),
        flowName: '',
        flowId: '',
        screenHeight: {height: ''},
        drawerStyle: {height: 800, width: 1600},
        globalVariableVisible: false,
        globalVariables: [],
        deleteGlobalVariables: [],
        indentDrawer: false,
        nounDrawer: false,
        testDrawer: false,
        nodeDrawer: false,
        fileDrawer: false,
        nodes: [],
        nodeName: '',
        containerId: 'mountNode',
        navId: 'win',
        miniMap: null,
        grid: null,
        graph: null,
        Util: null,
        nodeModel: null,
        selectItem: null,//选中的item(node or edge)
        lastItem: null,
        copyItem: null,
        redoList: [],//重做
        undoList: [],//撤销
        redoClass:{color:'gray'},
        undoClass:{color:'gray'},
        saveFlag:true,
        nodeData: [
          {
            name: '开始节点',
            label: '开始节点',
            type: 'customNode',
            color: '#153',
            // inPoints: [[0, 0.5]],
            outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          },
          {
            name: '下级菜单',
            label: '下级菜单',
            type: 'customNode',
            color: '#000',
            inPoints: [[0, 0.5]],
            outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          },
          {
            name: '语音节点',
            label: '语音节点',
            type: 'customNode',
            color: '#00BFFF',
            inPoints: [[0, 0.5]],
            outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          },
          {
            name: '转接节点',
            label: '转接节点',
            type: 'customNode',
            color: '#FF6A6A',
            inPoints: [[0, 0.5]],
            // outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          },
          {
            name: 'HTTP节点',
            label: 'HTTP节点',
            type: 'customNode',
            color: '#8B8682',
            inPoints: [[0, 0.5]],
            outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          },
          {
            name: '判断节点',
            label: '判断节点',
            type: 'customNode',
            color: '#8B8642',
            inPoints: [[0, 0.5]],
            outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          },
          {
            name: '跳转节点',
            label: '跳转节点',
            type: 'customNode',
            color: '#3B9342',
            inPoints: [[0, 0.5]],
            outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          },
          {
            name: '重听节点',
            label: '重听节点',
            type: 'customNode',
            color: '#8DB6CD',
            inPoints: [[0, 0.5]],
            //outPoints: [[1, 0.5]],
            size: '100*35',
            nodeData:null,
            x: 0,
            y: 0,
          }
        ],
        data: {
          // 点集
          nodes: [],
          // 边集
          edges: []
        },
        offsetX: 0,
        offsetY: 0,
        initNode:null,
        deleteEdges:[],
        deleteNodes:[],
        model:false,
        treeId:'',
        timeFlag: '',
      }
    },
    methods:{
      resetData() {
        this.saveFlag = true;
        this.paramListHttp = [];
        this.paramList = [];
        this.deleteEdges = []
        this.deleteNodes = []
        this.data = {
          nodes: [],
          edges: []
        }
        this.globalVariables = []
        this.deleteGlobalVariables = []
        this.indentDrawer = false
        this.nounDrawer = false
        this.testDrawer = false
        this.nodeDrawer = false
        this.nodes = []
        this.nodeName = ''
        this.nodeModel = null
        this.selectItem = null//选中的item(node or edge)
        this.lastItem = null
        this.copyItem = null
        this.redoList = []//重做
        this.undoList = []//撤销
      },
      closeDrawer(val) {
        this.fileDrawer = false
      },
      changeNodeStation(value) {
        let node = this.graph.findById(value+'')
        if (node) {
          this.graph.focusItem(node)
          //this.graph.moveTo(-80,80)
        }
      },
      updateJudgeLabel(judge) {
        let edgeId = judge.id;
        if(!edgeId){
          edgeId = judge.edgeId;
        }
        if(edgeId.indexOf("edge") == -1){
          edgeId = 'edge'+edgeId;
        }
        let edge = null
        if (edgeId) {
          edge = this.graph.findById(edgeId);
        } else {
          edge = this.graph.find('edge',edge=>{
            return edge.get('model').targetId === judge.nextSceneId && edge.get('model').sourceId === judge.rsId
          })
        }
        if (edge) {
          let model = {
            label: judge.name
          }
          this.graph.update(edge,model)
        }
      },
      updateRecognize(recognize, indent) {
        let edgeId = recognize.id;
        if(!edgeId){
          edgeId = recognize.edgeId;
        }
        if(edgeId.indexOf("edge") == -1){
          edgeId = 'edge'+edgeId;
        }
        let edge = null
        if (edgeId) {
          edge = this.graph.findById(edgeId);
        } else {
          edge = this.graph.find('edge',edge=>{
            return edge.get('model').targetId === recognize.nextSceneId && edge.get('model').sourceId === recognize.rsId
          })
        }
        if (edge) {
          let model = {
            label: indent.name
          }
          this.graph.update(edge,model)
        }
      },
      deleteJudge(judge) {
        let judgeId = judge.id;
        if(!judgeId){
          judgeId = judge.edgeId;
        }
        if(judgeId.indexOf("edge") == -1){
          judgeId = 'edge'+judgeId;
        }
        let edge = null
        if (judgeId) {
          edge = this.graph.findById(judgeId);
        } else {
          edge = this.graph.find('edge',edge=>{
            return edge.get('model').targetId === judge.nextId && edge.get('model').sourceId === judge.rsId
          })
        }
        if (edge) {
          this.deleteItem(edge)
        }
      },
      deleteRecognize(recognize) {
        let edgeId = recognize.id;
        if(!edgeId){
          edgeId = recognize.edgeId;
        }
        if(edgeId.indexOf("edge") == -1){
          edgeId = 'edge'+edgeId;
        }
        let edge = null
        if (edgeId) {
          edge = this.graph.findById(edgeId);
        } else {
          edge = this.graph.find('edge',edge=>{
            return edge.get('model').targetId === recognize.nextSceneId && edge.get('model').sourceId === recognize.rsId
          })
          /*if (edge.length > 0) {
            edge = edge[0]
          }*/
        }
        this.deleteItem(edge)
      },
      updateNode(id,value) {
        const model = {
          label: value
        }
        this.graph.update(this.selectItem, model)
        this.nodes.forEach(node=>{
          if (node.id === id) {
            node.label = value;
          }
        })
      },
      receivedData(data) {
        //更新节点数据
        let id = data.scene.id
        if (id) {
          let model = {
            nodeData:data
          }
          if (this.graph) {
            if (this.nodeDrawer) {
              if (this.lastItem) {
                //更新上次的
                this.graph.update(this.lastItem,model);
              }
            } else {
              if (this.selectItem) {
                //
                this.graph.update(this.selectItem, model);
                this.selectItem = null
              }
            }
          }

        }
      },
      closeNodeDrawer(val) {
        this.nodeDrawer = false
      },
      exitPage(){
        this.$Modal.confirm({
          title: '提示',
          content: "是否确定返回",
          onOk: () => {
            this.$emit("closeIvrSetting",true);
          }
        });
      },
      saveFlow() {
        if(this.saveFlag){
          this.saveFlag = false;
          let data = this.graph.save()
          let edgeArr = []
          let nodeArr = []
          let flag = true;
          if (data) {
            let edges = data.edges
            let nodes = data.nodes
            if (nodes.length <= 0) {
              this.$Message.info('流程数据为空')
            }
            if (edges.length > 0) {
              edges.forEach(edge=>{
                let json = {}
                json.targetId = edge.targetId;
                json.sourceId = edge.sourceId;
                json.isTop = edge.isTop;
                if (edge.tempId) {
                  json.id = edge.tempId;
                } else {
                  json.id = '';
                }
                if('1' != edge.isTop){
                  edge.isTop = '0';
                }
                if('1' != edge.isNode){
                  edge.isNode = '0';
                }
                let label = edge.label;
                if(label.indexOf("按键") > -1){
                  edge.isNode = '1';
                }
                json.isTop = edge.isTop;

                json.label = edge.label;
                json.isNode = edge.isNode;
                json.ivrId = this.flowId;
                edgeArr.push(json)
              });
            }
            if (nodes.length > 0) {
              nodes.forEach(node=>{
                let json = {}
                json.id = node.id
                json.nodeId = node.id
                json.ivrId = this.flowId
                json.label = node.label
                json.x = node.x
                json.y = node.y
                json.isTop = node.isTop;
                if (node.name === '开始节点') {
                  json.type = '0'
                }else if (node.name === '下级菜单') {
                  json.type = '1'
                }else if (node.name === '转接节点') {
                  json.type = '2'
                }else if (node.name === '语音节点') {
                  json.type = '5'
                }else if (node.name === '重听节点') {
                  json.type = '6'
                }else if (node.name === 'HTTP节点') {
                  json.type = '7'
                }else if (node.name === '判断节点') {
                  json.type = '8'
                }else if (node.name === '跳转节点') {
                  json.type = '10'
                }
                let newData = JSON.parse(JSON.stringify(node.nodeData));
                if((newData  && newData.uaIvrDetail) || json.type == '6'){
                  if('6' != json.type){
                    if('1' == json.type && !newData.uaIvrDetail.voiceFile){
                      this.$message.warning('请选择'+node.label+'的语音文件');
                      flag = false;
                    }
                    newData.uaIvrDetail.isTimeoutBusiness = newData.uaIvrDetail.isTimeoutBusiness?'1':'0';
                    newData.uaIvrDetail.isCallExtension = newData.uaIvrDetail.isCallExtension?'1':'0';
                    newData.uaIvrDetail.highSet = newData.uaIvrDetail.highSet?'1':'0';
                    newData.uaIvrDetail.isSendSms = newData.uaIvrDetail.isSendSms?'1':'0';
                    newData.uaIvrDetail.isSmsGather = newData.uaIvrDetail.isSmsGather?'1':'0';
                    newData.uaIvrDetail.isReceiver = newData.uaIvrDetail.isReceiver?'1':'0';
                    if('5' == json.type){
                      if(newData.uaIvrDetail.receiver){
                        newData.uaIvrDetail.receiver = newData.uaIvrDetail.receiver +"~"+node.label;
                      }
                    }
                    if('7' == json.type){
                      let httpList = newData.nodeHttpList;
                      if(null != httpList && httpList.url){
                        if(null != httpList.head && httpList.head.length > 0){
                          let param = {};
                          for (let i=0;i<httpList.head.length;i++){
                            let key = httpList.head[i].name;
                            let value = httpList.head[i].value;
                            param[key] = value;
                          }
                          newData.nodeHttpList.head = param;
                        }else{
                          newData.nodeHttpList.head="";
                        }
                        let receiveList=newData.nodeHttpList.receiver.split(",");
                        let newReceive = "";
                        for(let i=0;i<receiveList.length;i++){
                          newReceive = newReceive+","+receiveList[i]+"~"+node.label;
                        }
                        if(newReceive){
                          newReceive = newReceive.substr(1,newReceive.length);
                          newData.nodeHttpList.receiver = newReceive;
                        }
                        if(null != newData.recognizes && newData.recognizes.length > 0){
                          for(let i=0;i<newData.recognizes.length;i++){
                            if("success" == newData.recognizes[i].funcKey){
                              newData.nodeHttpList.successNextId = newData.recognizes[i].nodeId;
                            }
                            if("fail" == newData.recognizes[i].funcKey){
                              newData.nodeHttpList.failNextId = newData.recognizes[i].nodeId;
                            }
                          }
                        }else{
                          if(!newData.nodeHttpList.successTargetId || !newData.nodeHttpList.failTargetId){
                            this.$message.warning('请完善'+node.label+'的分支流程');
                            flag = false;
                            return false;
                          }
                          newData.nodeHttpList.successNextId = newData.nodeHttpList.successTargetId;
                          newData.nodeHttpList.failNextId = newData.nodeHttpList.failTargetId;
                        }
                        if(!newData.nodeHttpList.failNextId || !newData.nodeHttpList.successNextId){
                          this.$message.warning('请完善'+node.label+'的分支流程');
                          flag = false;
                          return false;
                        }
                        if(newData.nodeHttpList.httpVariable){
                          let newVariable = newData.nodeHttpList.httpVariable;
                          for (let p = 0;p < newVariable.length;p++){
                            if('0' == newVariable[p].type){
                              let newValueOne = 'callcenter_number';
                              if('客户呼叫ID' == newVariable[p].requestKey || 'customer_uuid' == newVariable[p].requestKey){
                                newValueOne = "customer_uuid";
                              }else if('客户号码' == newVariable[p].requestKey || 'customer_number' == newVariable[p].requestKey){
                                newValueOne = "customer_number";
                              }
                              newData.nodeHttpList.httpVariable[p].requestKey = newValueOne;
                            }
                          }
                        }
                      }
                    }
                    // if('8' == json.type){
                    //   let judgeList = newData.judgeElementList;
                    // }
                    json.nodeData = JSON.stringify(newData);
                  }
                  if('6' == json.type){
                    if(!newData){
                      newData = {};
                    }
                    newData.uaIvrDetail = {};
                    json.nodeData = newData;
                  }
                }else{
                  if('开始节点' != node.label){
                    this.$message.warning('请完善'+node.label+'的节点数据');
                    flag = false;
                    return false;
                  }
                }
                nodeArr.push(json)
              })
            }
            if(!flag){
              this.saveFlag = true;
              return false;
            }
            let param = {
              id:this.flowId,
              nodes:JSON.stringify(nodeArr),
              edges:JSON.stringify(edgeArr),
              menuId:'',
              journalType:'系统管理=>cti设置=>IVR配置保存',
              timeFlag: this.timeFlag,
            }
            this.$http.post('/ivrDesign/doSaveIvrDetail.json',param).then(res=>{
              let response = res.data
              if (response.flag !== '666') {
                this.$Message.error(response.msg);
                console.log('save flow data error',response.msg);
                this.saveFlag = true;
                return false;
              }
              this.$Message.success('保存成功！');
              this.resetData();
              this.initData(this.flowId);
            })
          }
        }else{
          this.$alert('请勿重复操作','提示',{
            confirmButtonText: '确定'
          })
        }
      },
      addIvrNodeOrEdge(type, item, pushUndo) {
        let list = []
        if (type === 'node') {
          item.label = item.label + uniqueId()
          if (!item.nodeData) {
            item.nodeData = this.generatorInitNodeData(item);
          }
          //
          let mtype = "1"
          if (item.name === '下级菜单') {
            mtype = '1'
          }else if (item.name === '语音节点') {
            mtype = '5'
          }else if (item.name === '判断节点') {
            mtype = '8'
          }else if (item.name === 'HTTP节点') {
            mtype = '7'
          }else if (item.name === '重听节点') {
            mtype = '6'
          }else if (item.name === '转接节点') {
            mtype = '2'
          }else if (item.name === '跳转节点') {
            mtype = '10'
          }
          item.rsType = mtype;
          item.ivrId = this.flowId;
          item.ivrDetailId = item.id;
          let json = {name:item.name,label:item.label,id:item.id, type: mtype,ivrDetailId:item.ivrDetailId,isTop:'0'};
          this.nodes.push(json);
        }
        if (type === 'edge') {
          if("下级菜单" != item.source._cfg.model.name && "跳转节点" == item.target._cfg.model.name){
            this.$message.warning('跳转节点只用连接于下级菜单');
            return false;
          }
          if("下级菜单" != item.source._cfg.model.name && "重听节点" == item.target._cfg.model.name){
            this.$message.warning('重听节点只用连接于下级菜单');
            return false;
          }
          switch (item.source._cfg.model.name) {
            case '下级菜单':
              if(item.source._cfg.model.nodeData.recognizes && item.source._cfg.model.nodeData.recognizes.length == 11){
                this.$message.info('下级菜单仅允许连接十一次');
                return false;
              }
              break;
            case '开始节点':
              this.$message.warning('开始节点仅允许连接一次');
              return false;
              break;
            case '语音节点':
              if(item.source._cfg.model.nodeData.recognizes && item.source._cfg.model.nodeData.recognizes.length == 1){
                this.$message.info('语音节点仅允许连接一次');
                return false;
              }
              break;
            case 'HTTP节点':
              if(item.source._cfg.model.nodeData.recognizes && item.source._cfg.model.nodeData.recognizes.length == 2){
                this.$message.info('HTTP节点仅允许连接两次');
                return false;
              }
              break
            case '跳转节点':
              if(item.source._cfg.model.nodeData.recognizes && item.source._cfg.model.nodeData.recognizes.length == 1){
                this.$message.info('跳转节点仅允许连接一次');
                return false;
              }
              break
          }

          let edge = this.graph.find('edge',edge=>{
            return edge.get('model').targetId === item.targetId && edge.get('model').sourceId === item.sourceId
          })
          if (edge) {
            this.$message.warning('数据已存在')
            return;
          }
          // let flag = false;
          let data = this.graph.save();
          let edges = data.edges
          for (let i=0;i<edges.length;i++){
            let newParam = edges[i];
            if(item.targetId === newParam.targetId && newParam.source._cfg.model.name !== '跳转节点' && item.source._cfg.model.name !== '跳转节点'){
              this.$message.warning('请先添加跳转节点');
              return;
            }
            if(item.sourceId === newParam.sourceId && newParam.source._cfg.model.name === '跳转节点'){
              this.$message.warning('跳转节点只能连接一次');
              return;
            }
          }
          // if(flag){
          //   this.$message.warning('请先添加跳转节点');
          //   return;
          // }
        }
        this.graph.add(type, item);
        if (type === 'edge') {
          this.addEdgeData(item)
        }
        list.push(item);
        //添加边,需要添加数据
        let key = 'add';
        //入栈
        if (pushUndo) {
          this.undoList.push({key, data: list});
        }
        //节点添加结束需要更新搜索下拉框的数据
      },
      getFormatPadding() {
        return this.Util.formatPadding(this.graph.get('fitViewPadding'))
      },
      getViewCenter() {
        const padding = this.getFormatPadding()
        const width = this.graph.get('width')
        const height = this.graph.get('height')
        return {
          x: (width - padding[2] - padding[3]) / 2 + padding[3],
          y: (height - padding[0] - padding[2]) / 2 + padding[0]
        }
      },
      generatorInitNodeData(model) {
        let nodeData = {}
        let scene = {id:model.id,isTop:'0',rsType:'1',ivrDetailId:model.id,label:model.label,ivrId:this.flowId}
        if (model.name === '下级菜单') {
          scene.rsType = '1'
        }else if (model.name === '语音节点') {
          scene.rsType = '5'
        }else if (model.name === '判断节点') {
          scene.rsType = '8'
        }else if (model.name === 'HTTP节点') {
          scene.rsType = '7'
        }else if (model.name === '重听节点') {
          scene.rsType = '6'
        }else if (model.name === '转接节点') {
          scene.rsType = '2'
        }else if (model.name === '跳转节点') {
          scene.rsType = '10'
        }
        nodeData.scene = scene;
        return nodeData
      },
      initData(id) {
        let self = this
        let param = {id: id};
        let that = this;
        this.resetData();
        this.$http.post("/ivrDesign/toIvrDetailIndex.json", param).then(res => {
          let response = res.data
          if (response.flag != '666') {
            that.$alert(response.msg,'提示',{
              confirmButtonText: '确定'
            })
            return false
          }
          that.timeFlag = response.obj.timeFlag;
          let nodes = response.obj.nodes;
          let edges = response.obj.edges;
          if (Array.isArray(nodes) && nodes.length > 0) {
            that.nodes = response.obj.nodes;
            nodes.forEach(async node => {
              let type = node.type + ''
              if (type === '0') {
                node.color = '#153'
                node.name = '开始节点'
              }else if (type === '1') {
                node.color = '#000'
                node.name = '下级菜单'
              } else if (type === '5') {
                node.color = '#00BFFF'
                node.name = '语音节点'
              } else if (type === '8') {
                node.color = '#8B8642'
                node.name = '判断节点'
              } else if (type === '7') {
                node.color = '#8B8682'
                node.name = 'HTTP节点'
              } else if (type === '2') {
                node.color = '#FF6A6A'
                node.name = '转接节点'
              } else if (type === '6') {
                node.color = '#8DB6CD'
                node.name = '重听节点'
              }else if (type === '10' || type === '3' || type === '4') {
                node.color = '#3B9342'
                node.name = '跳转节点'
                type = '10';
              }
              let newType = node.type;

              node.type = 'customNode';
              node.rsType = newType;
              //node.size = '100*35'
              node.nodeData = null;
              node.x = parseFloat(node.x)
              node.y = parseFloat(node.y)
              if (type !== '2' && type !== '6') {
                node.outPoints = [[1, 0.5]];
              }
              if (type !== '0') {
                node.inPoints = [[0, 0.5]]
              }
              if(type != '0' && type != '6'){
                let data = await self.initNodeData(node.ivrDetailId,newType,node.label);
                node.nodeData = data;
              }
            })
          }
          if (Array.isArray(edges) && edges.length > 0) {
            edges.forEach(edge => {
              edge.tempId = edge.id
              edge.id = 'edge'+edge.id
              edge.type = 'customEdge'
              edge.target = edge.targetId + ''
              edge.source = edge.sourceId + ''
            })
          }
          this.data.nodes = nodes
          this.data.edges = edges
          if (self.graph) {
            self.graph.data(this.data);
            self.graph.render()
          }
        })
      },
      initNodeData(sceneId,type,name) {
        let that = this
        return new Promise((resolve, reject) => {
          let param = {ivrType:type,ivrDetailId:sceneId,id:this.flowId}
          that.$http.post('/ivrDesign/doSelectOneIvrDetail.json',param).then(res=>{
            let response = res.data
            if (response.flag !== '666') {
              console.log('load node detail data error',response.msg)
              that.$message.error('加载'+name+'节点数据出错');
              resolve(null)
            }
            let newList = [{label:'客户呼叫ID',name:'customer_uuid',type:'0',detailId:''},{label:'客户号码',name:'customer_number',type:'0',detailId:''},{label:'接入号',name:'callcenter_number',type:'0',detailId:''}];
            if(null == that.paramListHttp || that.paramListHttp.length == 0){
              that.paramListHttp = newList;
            }
            if(response.obj.variablesElements && response.obj.variablesElements.length > 0 && that.paramList.length == 0){
              for(let i=0;i<response.obj.variablesElements.length;i++){
                let receiveList = {label:response.obj.variablesElements[i].variableLabel,name:response.obj.variablesElements[i].variableName,type:'2',detailId:response.obj.variablesElements[i].ivrDetailId};
                that.paramList.push(receiveList);
                that.paramListHttp.push(receiveList);
              }
            }
            resolve(response.obj)
          })
        })
      },
      bindEvents() {
        let that = this
        eventBus.$on('addItemIvr', item => {
          that.addIvrNodeOrEdge('edge', item, true)
        })

        eventBus.$on('editFlowIvr', item => {
          that.flowName = item.ivrName;
          that.flowId = item.id;
          that.resetData();
          that.initData(item.id);
          // that.initNodesData(item.id)
          //直接加载每一个数据
        })
        eventBus.$on('saveFlow',save=>{
          that.nodeDrawer = false
          if (save) {
            that.saveFlow()
          }
        })
      },
      handleDelete() {
        let item = this.selectItem
        if (item) {
          if("1" == item._cfg.model.isTop+""){
            this.$message.info('顶级节点不允许删除');
            return false;
          }
          this.deleteItem(item);
        }
        this.selectItem = null
      },
      handleClear() {
        let self = this
        this.$Modal.confirm({
          title:'提示',
          content:'清空画布不能撤销，是否确认清空画布？',
          onOk:()=>{
            this.initData(this.flowId);
          }
        })
      },
      clearData() {
        this.nodeDrawer = false
        this.nodes = []
        this.nodeName = ''
        this.nodeModel = null
        this.selectItem = null//选中的item(node or edge)
        this.lastItem = null
        this.copyItem = null
        this.redoList = []//重做
        this.undoList = []//撤销
        let data = this.graph.save()
        let nodes = data.nodes
        let edges = data.edges
        if (nodes.length > 0) {
          nodes.forEach(node=>{
            node.id += ''//字符化
            if (node.id.indexOf("customNode") < 0) {
              this.deleteNodes.push(node.id+'')
            }
          })
        }
        if (edges.length > 0) {
          edges.forEach(edge=>{
            if (edge.tempId) {
              this.deleteEdges.push(edge.tempId+'')
            }
          })
        }
        this.graph.clear()
      },
      deleteItem(item) {
        let self = this
        let graph = this.graph
        const list = []
        const deleteEdges = []
        if (item) {
          if (!item.isItem() || item.destroyed) {
            //不是节点直接返回
            return;
          }
          const autoPaint = graph.get('autoPaint')
          graph.setAutoPaint(false)
          //判断item是节点还是边
          let type = item.getType()
          let model = item
          if (type === 'node') {
            //节点,删除节点和边
            let edges = item.getEdges()
            model = item.getModel()
            model.type = item.getType()
            model.id = item.get('id')
            let deleteId = model.id + ''
            if (deleteId.indexOf('customNode') < 0) {
              self.deleteNodes.push(deleteId)
            }
            let node = this.nodes.find(node=>{
              return node.id === deleteId
            })
            let index = this.nodes.indexOf(node)
            if (index > -1) {
              this.nodes.splice(index,1)
            }
            edges.forEach(edge => {
              //判断边是否hover,click
              //防止悬浮在边上，删除造成节点是悬浮的状态
              let hover = edge.hasState('hover')
              if (hover) {
                graph.setItemState(edge, 'hover', false)
              }
              //判断边是否有记录的
              //记录删除的边
              let edgeModel = edge.getModel()
              //edgeModel.type = 'edge'
              edgeModel.id = edge.get('id')
              list.push(edgeModel);
              //真正的ID
              //记录删除的线
              let tempId = edgeModel.tempId
              if (tempId) {
                self.deleteEdges.push(tempId+'')
              }
              //graph.removeItem(edge);
              //添加进的线（出的线，会跟节点一起删除）

              deleteEdges.push(edgeModel)
            });
            //graph.removeItem(item)
            //存储到删除的集合，需要重做的集合
            self.nodeDrawer = false

          } else if (type === 'edge') {
            //边，删除边
            //存储到删除的集合，需要重做的集合
            model = item.getModel()
            model.type = item.getType()
            model.id = item.get('id')
            const targetNode = item.getTarget()
            const sourceNode = item.getSource()
            graph.setItemState(targetNode, 'hover', false)
            graph.setItemState(sourceNode, 'hover', false)
            // graph.removeItem(item)
            let tempId = model.tempId
            if (tempId) {
              self.deleteEdges.push(tempId+'')
            }
            deleteEdges.push(model)
          }
          if (deleteEdges.length > 0) {
            deleteEdges.forEach(edge=>{
              self.handleDeleteData(edge)
            })
          }
          //end
          list.push(model);
          let key = 'delete'
          this.undoList.push({key, data: list})
          //删除
          graph.remove(item)
          self.redoList = []
          //self.selectItem = null
          graph.setAutoPaint(autoPaint)
          graph.paint()
        }
      },
      handleDeleteData(edge) {
        let sourceNode = this.graph.findById(edge.sourceId)
        let sourceModel = sourceNode.getModel()
        let data = null
        if (sourceModel.nodeData) {
          data = sourceModel.nodeData;
        }
        if (data) {
          let index = -1
          if (data.recognizes) {
            for (let i = 0; i < data.recognizes.length; i++) {
              let rec = data.recognizes[i]
              let edgeId = rec.id;
              if(!edgeId){
                edgeId = rec.edgeId;
              }
              if(edgeId.indexOf("edge") == -1){
                edgeId = 'edge'+edgeId;
              }
              if (edgeId) {
                if (edgeId === edge.id) {
                  index = i
                  break
                }
              } else {
                if (edge.sourceId === rec.rsId && edge.targetId === rec.nextSceneId) {
                  index = i
                  break
                }
              }
            }
            if (index>-1) {
              let recognize = data.recognizes[index]
              data.recognizes.splice(index,1);
              if (this.nodeDrawer) {
                if (this.nodeModel.id === edge.sourceId) {
                  eventBus.$emit('deleteRecognize',recognize);
                }
              }
            }

          }
          if (data.judgeElementList && data.judgeElementList.judgeVariable) {
            for (let i = 0; i < data.judgeElementList.judgeVariable.length; i++) {
              let judge = data.judgeElementList.judgeVariable[i]
              let judgeId = judge.id;
              if(!judgeId){
                judgeId = judge.edgeId;
              }
              if(judgeId.indexOf("edge") == -1){
                judgeId = 'edge'+judgeId;
              }
              if (judgeId) {
                if (judgeId === edge.id) {
                  index = i
                  break
                }
              } else {
                if (edge.sourceId === judge.rsId && edge.targetId === judge.nextSceneId) {
                  index = i
                  break
                }
              }
            }
            if (index>-1) {
              let judge = data.judgeElementList.judgeVariable[index]
              let judgeId = judge.id;
              if(!judgeId){
                judgeId = judge.edgeId;
              }
              if(judgeId.indexOf("edge") == -1){
                judgeId = 'edge'+judgeId;
              }
              data.judgeElementList.judgeVariable.splice(index,1)
              if (this.nodeDrawer) {
                if (this.nodeModel.id === edge.sourceId) {
                  eventBus.$emit('deleteJudge',judge);
                }
              }
            }
          }
          let model = {
            nodeData:data
          }
          this.graph.update(sourceNode,model)
        }
      },
      handleZoomIn() {
        const currentZoom = this.graph.getZoom()
        this.graph.zoomTo(currentZoom + 0.1, this.getViewCenter())
      },
      handleZoomOut() {
        const currentZoom = this.graph.getZoom()
        this.graph.zoomTo(currentZoom - 0.1, this.getViewCenter())
      },
      handleResetZoom() {
        this.graph.zoomTo(1, this.getViewCenter())
        this.graph.fitCenter()
      },
      handleDragstart(e) {
        this.offsetX = e.offsetX
        this.offsetY = e.offsetY
      },
      handleDragEnd(e, item) {
        let data = {}
        Object.assign(data, item)
        data.offsetX = this.offsetX
        data.offsetY = this.offsetY
        const graph = this.graph
        const xy = graph.getPointByClient(e.x, e.y)
        data.x = xy.x
        data.y = xy.y
        data.size = item.size.split('*')
        data.id = data.type + uniqueId();
        this.addIvrNodeOrEdge('node', data, true)
      },
      checkPhoneNumber:function(event){
        let name=event.currentTarget.name;
        let value=event.currentTarget.value;
        let reg=/^[0-9]*$/;
        if(!reg.test(value)){
          this.$Modal.info({
            title:'提示',
            content:name+"只能输入数字"
          });
          event.currentTarget.value=event.currentTarget.value.replace(/[^\d]/g,'');
          return false;
        }
      },
      generatorInitEdgeData(model, type) {
        let json = {}
        let sourceModel = this.graph.findById(model.sourceId).getModel()
        let targetModel = this.graph.findById(model.targetId).getModel()
        let sourceId = ''
        let targetId = ''
        if (sourceModel) {
          sourceId = sourceModel.id
        }
        if (targetModel){
          targetId = targetModel.id
        }
        if (type === 1) {
          json.id = ''
          json.rsId = sourceId
          json.trigger = 1
          json.symbol = '=='
          json.purposeId = ''
          json.nodeId = targetId
          json.isTop = '0';
          json.isNode = '0';
          //添加线ID
          json.edgeId = model.id
        }else if (type === 2) {
          //branches
          json.id = '';
          json.isTop = '0';
          json.isNode = '0';
          json.rsId = sourceId;
          json.name = model.label;
          json.edgeId = model.id;
          json.value = '';
          json.type = '';
          json.seq = 0;
          json.nextId = targetId;
          json.isDefalut = '0';
        }
        return json
      },
      addEdgeData(item){
        //新添的全是空
        let sourceId = item.sourceId
        let targetId = item.targetId
        let node = this.graph.findById(sourceId)
        let sourceModel = node.getModel()
        if (sourceModel) {
          let name = sourceModel.name
          let json = {}
          let nodeData = sourceModel.nodeData
          if (name === '下级菜单' || name === '语音节点' || name === 'HTTP节点') {
            json = this.generatorInitEdgeData(item,1)
            //生成一个识别数据,加线条ID
            //无论打开与否
            //更新当前添加节点得识别部分的数据
            if(!nodeData.recognizes){
              nodeData.recognizes = [];
            }
            nodeData.recognizes.push(json)
            let model = {
              nodeData:nodeData
            }
            this.graph.update(node,model)
            this.$message.info('请完善节点动作按键')
            if (this.nodeDrawer) {
              if (this.nodeModel.id === sourceId) {
                eventBus.$emit('addRecognize',json);
              }
            }
          }else if (name === '判断节点') {
            json = this.generatorInitEdgeData(item,2)
            if(nodeData.judgeElementList){
              nodeData.judgeElementList.receiver = "";
            }else{
              nodeData.judgeElementList = {};
              nodeData.judgeElementList.receiver = "";
            }
            if(null != nodeData.judgeElementList.judgeVariable && nodeData.judgeElementList.judgeVariable.length > 0){
              json.seq=parseInt(nodeData.judgeElementList.judgeVariable[nodeData.judgeElementList.judgeVariable.length-1].seq) + 1 ;
              nodeData.judgeElementList.judgeVariable.push(json);
            }else{
              nodeData.judgeElementList.judgeVariable = [];
              json.seq=0;
              nodeData.judgeElementList.judgeVariable.push(json);
            }
            let model = {
              nodeData:nodeData
            }
            this.graph.update(node,model)
            this.$message.info('请完善条件判断')
            if (this.nodeDrawer) {
              if (this.nodeModel.id === sourceId) {
                eventBus.$emit('addJudgeBranch',json)
              }
            }
          }
        }
      },
      initBind() {
        let graph = this.graph;
        let self = this;
        if (graph) {
          /*节点 鼠标进入事件*/
          graph.on('node:mouseover', e => {
            const item = e.item;
            const graph = self.graph;
            const group = item.getContainer()
            if (e.target.attrs.isOutPointOut || e.target.attrs.isOutPoint) {
              group.find(g => {
                if (g.attrs.isInPoint || g.attrs.isOutPoint) {
                  g.attr("fill", "#fff")
                }
                if (g.attrs.isOutPoint) {
                  if (g.attrs.id === e.target.attrs.parent) {
                    group.find(gr => {
                      if (gr.attrs.id === g.attrs.id) {
                        gr.attr('fill', "#1890ff")
                        gr.attr('opacity', 1)
                      }
                    })
                  }
                  if (g.attrs.id === e.target.attrs.id) {
                    g.attr("fill", "#1890ff")
                    g.attr('opacity', 1)
                  }

                }
              });
              e.target.attr("cursor", "crosshair");
              this.graph.paint();
            }
            if (item.hasState('selected')) {
              return
            } else {
              graph.setItemState(item, 'hover', true);
            }
            graph.paint();
          });
          /*节点 鼠标离开事件*/
          graph.on('node:mouseleave', e => {
            const item = e.item;
            const graph = self.graph;
            const group = item.getContainer()
            group.find(g => {
              if (g.attrs.isInPoint || g.attrs.isOutPoint) {
                g.attr("fill", "#fff")
              }
            });
            if (!item.hasState('selected')) {
              graph.setItemState(item, 'hover', false)
            }
            graph.paint();

          });
          /*节点 鼠标点击事件*/
          graph.on('node:click', ev => {
            //self.nodeDrawer = false
            const autoPaint = graph.get('autoPaint')
            graph.setAutoPaint(false)
            const clickNodes = graph.findAllByState('node', 'selected')
            clickNodes.forEach(node => {
              graph.setItemState(node, 'selected', false)
            })
            const clickEdges = graph.findAllByState('edge', 'selected')
            clickEdges.forEach(edge => {
              graph.setItemState(edge, 'selected', false)
            })

            const nodeItem = ev.item
            graph.setItemState(nodeItem, 'selected', true)
            graph.paint()
            graph.setAutoPaint(autoPaint)
            self.lastItem = self.selectItem//记录上一次的数据
            self.selectItem = nodeItem
            let model = nodeItem.getModel();
            if(model.name == '重听节点' || model.name == '开始节点'){
              return false;
            }
            self.nodeModel = model
            self.currentNode = nodeItem;
            //self.nodeDrawer = true
            /*setTimeout(()=>{

              self.nodeDrawer = true
            },1000)*/
            if (self.nodeDrawer) {
              self.nodeDrawer = false
              setTimeout(() => {
                self.lastItem = self.selectItem//记录上一次的数据
                self.selectItem = nodeItem
                self.nodeDrawer = true
              }, 500)
            } else {
              self.nodeDrawer = true;
            }
          })
          /*节点 鼠标落下事件*/
          graph.on('node:mousedown',e => {
            if (e.target.attrs.isOutPoint || e.target.attrs.isOutPointOut) {
              self.graph.setMode('addEdge')
              //补偿当节点数据没有加载就连线会失败的问题
              const nodeItem = e.item
              const nodeModel = nodeItem.getModel()
              /*if (!nodeModel.nodeData) {
                let reg = /^[0-9]+.?[0-9]*$/;
                if (reg.test(nodeModel.id)) {
                  let model = {
                    nodeData:data
                  }
                  self.graph.update(nodeItem,model)
                }
              }*/
            } else {
              self.graph.setMode('default')
            }
          })
          graph.on('node:mouseup', e => {
            self.graph.setMode('default')
          })
          /*边 点击事件*/
          graph.on('edge:click', ev => {
            const autoPaint = graph.get('autoPaint')
            graph.setAutoPaint(false)
            const clickEdges = graph.findAllByState('edge', 'selected')
            clickEdges.forEach(edge => {
              graph.setItemState(edge, 'selected', false)
            })
            const clickNodes = graph.findAllByState('node', 'selected')
            clickNodes.forEach(node => {
              graph.setItemState(node, 'selected', false)
            })
            const edgeItem = ev.item
            graph.setItemState(edgeItem, 'selected', true)
            graph.setAutoPaint(autoPaint)
            graph.paint()
            self.selectItem = edgeItem
          })
          /*边 鼠标进入事件*/
          graph.on('edge:mouseover', ev => {
            try {
              const edgeItem = ev.item
              graph.setItemState(edgeItem, 'hover', true)
              const targetNode = edgeItem.getTarget()
              const sourceNode = edgeItem.getSource()
              graph.setItemState(targetNode, 'hover', true)
              graph.setItemState(sourceNode, 'hover', true)
            }catch (e) {
              console.log(e)
            }

          });
          /*边 鼠标离开事件*/
          graph.on('edge:mouseleave', ev => {
            try {
              const edgeItem = ev.item
              if (!edgeItem.hasState('selected')) {
                graph.setItemState(edgeItem, 'hover', false);
              }
              const targetNode = edgeItem.getTarget()
              const sourceNode = edgeItem.getSource()
              graph.setItemState(targetNode, 'hover', false)
              graph.setItemState(sourceNode, 'hover', false)
            }catch (e) {
              console.log(e)
            }
          });
          /*画布点击事件*/
          graph.on('canvas:click', ev => {
            const autoPaint = graph.get('autoPaint')
            graph.setAutoPaint(false)
            //取消所有的节点选中
            const nodeItems = graph.findAllByState('node', 'selected')
            nodeItems.forEach(node => {
              graph.setItemState(node, 'selected', false)
            })
            //取消所有的边选中
            const edgeItems = graph.findAllByState('edge', 'selected')
            edgeItems.forEach(edge => {
              graph.setItemState(edge, 'selected', false)
            })
            graph.setAutoPaint(autoPaint)
            graph.paint()
            //关闭抽屉
            self.nodeDrawer = false
            //self.selectItem = null
          })
          /*画布上鼠标抬起事件*/
          graph.on('canvas:mouseup', ev => {
            const model = graph.getCurrentMode()
            if (model === 'addEdge') {
              graph.setMode('default')
            }
          })
          graph.on('canvas:mouseenter',e=>{
            self.graph.on('keydown',e=>{
              const keyCode = e.keyCode || e.which
            })
          })
          graph.on('canvas:mouseleave',e=>{
            self.graph.off('keydown')
          })
          //绑定添加事件，对添加得数据进行更新
          graph.on('afteradditem',e=>{
            let type = e.model.type;
            if (self.deleteNodes.length > 0 || self.deleteEdges.length >0) {
              //如果是重做，添加需要删除已删除的节点数据

              if (type === 'customNode') {
                let ivrDetailId = e.model.id + ''
                if (self.deleteNodes.length > 0) {
                  let index = self.deleteNodes.indexOf(ivrDetailId)
                  if (index > -1) {
                    self.deleteNodes.splice(index,1)
                  }
                }
              }else if (type === 'customEdge') {
                let tempId = e.model.tempId
                if (tempId) {
                  let index = self.deleteEdges.indexOf(tempId)
                  if (index > -1) {
                    self.deleteEdges.splice(index,1)
                  }
                }
              }
            }
          })
        }
      },
      initG6() {
        let self = this
        self.Util = G6.Util
        self.grid = new G6.Grid()
        self.miniMap = new G6.Minimap({
          container: self.navId,
          size: [150, 200],
          className: 'minimap',
          type: 'delegate'
        })
        self.graph = new G6.Graph({
          container: self.containerId,
          nodeStateStyles: {
            // 鼠标 hover 上节点，即 hover 状态为 true 时的样式
            hover: {
              fill: 'lightsteelblue',
            },
            // 鼠标点击节点，即 click 状态为 true 时的样式
            click: {
              stroke: '#000',
              lineWidth: 3,
            },
          },
          // 边不同状态下的样式集合
          edgeStateStyles: {
            // 鼠标点击边，即 click 状态为 true 时的样式
            click: {
              stroke: 'steelblue',
            },
          },
          modes: {
            default: [
              'drag-canvas',
              {
                type: 'zoom-canvas',
                minZoom: 0.5,
                maxZoom: 10
              },
              {
                type: 'drag-node',
                enableDelegate: true
              },
              {
                type: 'click-select',
                trigger: 'ctrl'
              },
              {
                type: 'brush-select',
                trigger: 'shift'
              },
            ],
            addEdge: ['ivr-add-edge'],
          },
          height: self.drawerStyle.height,
          width: self.drawerStyle.width,
          minZoom: 0.5,
          maxZoom: 10,
          plugins: [self.miniMap,self.grid]
        })
        self.graph.data(this.data)
        self.graph.render()
      },
    },
    created(){
      this.screenHeight.height=this.mountHeight(91);
    },
    destroyed() {
      eventBus.$off('editFlowIvr')
      eventBus.$off('addItemIvr')
      eventBus.$off('saveFlow')
    },
    mounted(){
      this.$nextTick(() => {
        this.initG6();
        initBehaviors();
        this.bindEvents();
        this.initBind();
      })
    }
  }
</script>

<style scoped lang="css">
  .el-header,.el-footer {
    background-color: #B3C0D1;
    color: #333;
    /*text-align: center;*/
    line-height: 40px;
    height: 40px!important;
    min-height: 40px!important;
    max-height: 40px!important;
  }
  .el-aside{
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 70px;
  }
  .el-main{
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
    padding: 0;
  }
  .flow-title{
    overflow: hidden;
    text-align: center;
    display: inline-block;
    width: 150px;
    white-space: nowrap;
    text-overflow: ellipsis;

    float: left;
    font-size: 20px;
    font-weight: bold;
  }
  li i{
    cursor: pointer;
    font-size: 23px;
  }
  .header li {
    float: left;
    margin-left: 12px;
  }
  .header li i {
    font-size: 16px;
    color: #2d8cf0;
    cursor: pointer;
  }
  .header{
    list-style: none;
    margin-left: 60px;
  }
  .popperClass{
    height: auto;
    width: auto;
    border-radius: 1px;
  }
  a {
    color: #2d8cf0;
  }
  .win{
    position: absolute;
    bottom: 20px;
    right: 10px;
    height: 200px;
    width: 150px;
    color: gray;
    border: 1px solid #8d8f93;
  }
  .nodeClass{
    color: rgba(0,0,0,0.65);
    border-radius: 4px;
    width: 100px;
    min-width: 100px;
    height: 30px;
    line-height: 30px;
    border: 1px solid rgba(0,0,0,0);
    list-style-type: none;
  }
  .nodeClass :hover{
    background: white;
    border: 1px solid #ced4d9;
    cursor: move;
  }
  .left-icon{
    width: 28px;
    height: 28px;
    cursor: pointer;
  }
  .top-icon{
    width: 18px;
    height: 18px;
  }
  .nodeDiv{
    padding-top: 7px;
    display: flex;
  }
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/CTIConfigure/IVRDetail.vue